(function () {
    'use strict';

    angular
        .module('appback')
        .controller('AppController', AppController)

    // Ids de los estados de orden: los pone el layout desde las constantes de
    // common\models\OrderState (los ids cambian entre entornos, no se fijan aquí).
    var ORDER_STATE = window.ORDER_STATE || {};

    AppController.$inject = ['FOrderService', "$http", "$timeout", "$uibModal", "$log", "$document", "$sce"];

    function AppController(FOrderService, $http, $timeout, $uibModal, $log, $document, $sce) {

        var vm = this;
        vm.currentOrder;

        vm.getOrder = function () {

            const url = new URL($document[0].URL);
            const id = url.searchParams.get("id");

            return FOrderService.Getorder(id).then(function (data) {

                vm.currentOrder = data;

                vm.getTime(vm.currentOrder);

            }, function (error) {
                console.log("error:", error);
            });

        };

        vm.getTime = function (order) {

            return FOrderService.Getorder(order.id).then(function (data) {

                var end = 0;

                if (data.state.id == ORDER_STATE.BOPOSRELEASED) {
                    end = new Date();
                } else if (data.state.id == ORDER_STATE.BOPOSCLOSED) {
                    end = new Date(data.ending_date);

                }

                const now = new Date(data.starting_date);

                const diffMs = end - now;

                const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
                const hours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

                order.timeInProgress =
                    `${String(days).padStart(2, '0')}d ` +
                    `${String(hours).padStart(2, '0')}:` +
                    `${String(minutes).padStart(2, '0')}:` +
                    `${String(seconds).padStart(2, '0')}`;

                return order.timeInProgress;

            }, function (error) {

                console.log(error);

            });
        };

    }

})();